<div class="mb-myaccount-contact"
     *ngIf="(contactData$| async) as contactData">
  <h3 [innerHTML]="'mbMyAccount.contact.help' | cxTranslate"></h3>
  <p [innerHTML]="'mbMyAccount.contact.support' | cxTranslate"></p>
  <h3 [innerHTML]="'mbMyAccount.contact.emailSupport' | cxTranslate"></h3>
  <div class="d-flex flex-row">
    <div class="mr-2">
      <img alt="email"
           class="contact-box-in-myAccount-icon"
           src="assets/images/icon_envelope_purple.svg"
           title="email">
    </div>
    <div class="contact-line-myAccount">
      <a [href]="'mailto:' + contactData.ordersEmail"
         class="text-white"
         [innerHTML]="'mbMyAccount.contact.emailSupportMail' | cxTranslate">
      </a>
    </div>
  </div>
  <h3 [innerHTML]="'mbMyAccount.contact.hotline' | cxTranslate"></h3>
  <div class="d-flex flex-row">
    <div class="mr-2">
      <img alt="phone"
           class="contact-box-in-myAccount-icon"
           src="assets/images/icon_phone_purple.svg"
           title="phone">
    </div>
    <div class="contact-line-myAccount">
      <a [href]="'tel:' + contactData.ordersPhone"
         class="text-white"
         [innerHTML]="contactData.ordersPhone">
      </a>
    </div>
  </div>
</div>
